import { ConfigurationOptions } from "@genesys/cloud-frontend/dist/mjs/api-base";
import config from "config";

// Export header names as constants for reuse
export const HEADER_GENESYS_APP = "Genesys-App";
export const HEADER_CLIENT_PATH = "ININ-Client-Path";

// Export header values as constants or functions
export const getGenesysAppHeaderValue = () =>
    `quality_forms_webui/${config.appVersion || "unknownVersion"}`;

export const API_CONFIGURATION: ConfigurationOptions = {
    headers: {
        [HEADER_GENESYS_APP]: getGenesysAppHeaderValue(),
    },
};
